const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
];

export function formatYearMonthKey(value: any, fallback: string = ''): string {
    if (!value) return '';

    const numericValue = Number(value);
    const year = Math.floor(numericValue / 100);
    const month = numericValue % 100;

    if (month >= 1 && month <= 12) {
        return `${MONTH_NAMES[month - 1]}, ${year}`;
    }

    return fallback;
}
